import { useState } from 'react';
import {
  Wrapper,
  HeroShell,
  HeroContent,
  Eyebrow,
  Card,
  Title,
  Accent,
  Description,
  SimpleList,
  SimplePill,
  DownloadButtons,
  DownloadButton,
  QRLink,
  RegisterButton,
  CardContent,
  CardHeader,
  CardIcon,
  CardTitle,
  CardDescription,
  LoginSectionStyled,
  LoginTitleStyled,
  LoginButtonStyled
} from './RegisterLanding.styles.ts';
import QRCodeModal from '../QRCodeModal/QRCodeModal.tsx';
import RegisterVerificationModal from '../RegisterVerificationModal/RegisterVerificationModal';
import appStoreBadge from '../../assets/app-store-badge.svg';
import googlePlayBadge from '../../assets/play-store-badge.svg';
import deviceIcon from '../../assets/mobile-device-icon.svg';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../constants';
import useDeviceType from '../../hooks/useDevice';

const RegisterLanding = () => {
  const device = useDeviceType();
  const isMobile = device === 'mobile';
  const [qrOpen, setQROpen] = useState(false);
  const [registerModalOpen, setRegisterModalOpen] = useState(false);

  return (
    <Wrapper>
      <HeroShell>
        <HeroContent>
          <Eyebrow>Admissions</Eyebrow>
          <Title>
            A simpler start at <Accent>Branham University</Accent>.
          </Title>
          <Description>
            Download the iDen2 app, verify your identity, and complete student registration in a few clear steps.
          </Description>
          <SimpleList>
            <SimplePill>Secure identity verification</SimplePill>
            <SimplePill>Mobile-friendly setup</SimplePill>
            <SimplePill>Fast access to your portal</SimplePill>
          </SimpleList>
        </HeroContent>

        <Card>
          <CardContent>
            <CardHeader>
              <CardIcon>
                <img src={deviceIcon} alt="Device Icon" height={32} />
              </CardIcon>
              <CardTitle>Download the iDen2 App</CardTitle>
            </CardHeader>
            <CardDescription>
              Use the app to complete identity verification with a government-issued ID.
            </CardDescription>
            <DownloadButtons
              style={{
                flexDirection: isMobile ? 'column' as const : 'row' as const,
                alignItems: isMobile ? 'stretch' as const : 'center' as const
              }}
            >
              <DownloadButton
                as="a"
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={isMobile ? { marginBottom: '0.75rem' } : { marginRight: '0.5rem' }}
              >
                <img src={appStoreBadge} alt="Download on the App Store" height={56} />
              </DownloadButton>
              <DownloadButton as="a" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
                <img src={googlePlayBadge} alt="Get it on Google Play" height={56} />
              </DownloadButton>
            </DownloadButtons>
            {!isMobile && (
              <QRLink as="button" type="button" onClick={() => setQROpen(true)}>
                View QR codes for download
              </QRLink>
            )}
            <RegisterButton onClick={() => setRegisterModalOpen(true)}>Register Now</RegisterButton>
            <QRCodeModal open={qrOpen} onClose={() => setQROpen(false)} />
            <LoginSectionStyled>
              <LoginTitleStyled>Returning Student?</LoginTitleStyled>
              <LoginButtonStyled>Login Here</LoginButtonStyled>
            </LoginSectionStyled>
          </CardContent>
        </Card>
      </HeroShell>

      <RegisterVerificationModal open={registerModalOpen} onClose={() => setRegisterModalOpen(false)} />
    </Wrapper>
  );
};

export default RegisterLanding;